import api from "./api";

export type BlogBlockType = "h1" | "h2" | "h3" | "h4" | "p";
export interface BlogBlock { type: BlogBlockType; text: string; }
export interface ManagedBlogPost {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  meta_title?: string | null;
  meta_description?: string | null;
  category: string;
  cover_image_url?: string | null;
  cover_image_alt?: string | null;
  content: BlogBlock[];
  is_published: boolean;
  author_name?: string | null;
  published_at?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}
export type BlogPayload = Omit<ManagedBlogPost, "id" | "author_name" | "published_at" | "created_at" | "updated_at">;

export const listManagedBlogs = async () => (await api.get<ManagedBlogPost[]>("/blogs")).data;
export const listPublishedBlogs = async () => (await api.get<ManagedBlogPost[]>("/blogs/public")).data;
export const getPublishedBlog = async (slug: string) => (await api.get<ManagedBlogPost>(`/blogs/public/${slug}`)).data;
export const createBlog = async (payload: BlogPayload) => (await api.post<ManagedBlogPost>("/blogs", payload)).data;
export const updateBlog = async (id: string, payload: BlogPayload) => (await api.put<ManagedBlogPost>(`/blogs/${id}`, payload)).data;
export const deleteBlog = async (id: string) => api.delete(`/blogs/${id}`);
export const uploadBlogCover = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return (await api.post<{ url: string }>("/blogs/upload-cover", form, { headers: { "Content-Type": "multipart/form-data" } })).data.url;
};

export const blogAssetUrl = (url?: string | null) => {
  if (!url || /^https?:\/\//.test(url)) return url || "";
  return `${(process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "")}${url.startsWith("/") ? url : `/${url}`}`;
};
